module.exports = __webpack_public_path__ + "img/proses_dispatch.d61bb961.svg";